import Image from 'app/Components/Shared/Image/image';
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import BtnWhiteBlackBorderBigSize from '../../../../Shared/Buttons/BtnWhiteBlackBorderBigSize';
import Copy from '../../images/copy.svg';
import TextInput from '../../../../Shared/TextInput/TextInput';
import Config from '../../../../../Config';
import EpiContext from '@episerver/spa-core/Spa';


const ConnectionDetailsPage = (props) => {
const [isCopyActivationCode, setIsCopyActivationCode] = useState(false);
const userName = props.internetDetails?.deviceUserName;

function handleOnContinue() {
        EpiContext.navigateTo(Config.lobbyUrl);
    };

    function handlePlaceholder(textToCopy) {
        return (
        <div className='placeholder-wrapper'>
            <button className='box-item-value' onClick={() => copyTextToClipboard(textToCopy)}>
                <Image src={Copy} alt='icon-copy' />
            </button>
        </div>
        );
    };


    function copyTextToClipboard(textToCopy) {
        if (!navigator.clipboard) {
            console.error('Clipboard API not supported');
            fallbackCopyTextToClipboard(textToCopy);
            return;
        }

        navigator.clipboard.writeText(textToCopy).then(function() {
            console.log('Text copied to clipboard successfully!');
            setIsCopyActivationCode(true);
            setTimeout(() => { setIsCopyActivationCode(false); }, 3000);
        }).catch(function(err) {
            console.error('Could not copy text: ', err);
        });
    }

    function fallbackCopyTextToClipboard(text) {
        const textArea = document.createElement("textarea");
        textArea.value = text;
        // Avoid scrolling to bottom
        textArea.style.top = "0";
        textArea.style.left = "0";
        textArea.style.position = "fixed";
        document.body.appendChild(textArea);
        textArea.focus();
        textArea.select();
        try {
            const successful = document.execCommand('copy');
            const msg = successful ? 'successful' : 'unsuccessful';
            console.log('Fallback: Copying text command was ' + msg);
            if(successful){
                setIsCopyActivationCode(true);
                setTimeout(() => { setIsCopyActivationCode(false); }, 3000);
            }
        } catch (err) {
            console.error('Fallback: Oops, unable to copy', err);
        }
        document.body.removeChild(textArea);
    }


  return (
   <div className='provider-connection-details-page'>
        {isCopyActivationCode && <span className='alert-copy-success'>הועתק בהצלחה!</span>}
        <div>
        <h1> פרטי ההתחברות לספק שלך</h1>
        <div className='input-wrapper'>
            <div className='title-text-input'>שם משתמש</div>
            <TextInput
             className='user-name-input'
             name='user'
             type='user'
             pattern='[0-9]*'
             id='user'
             autoComplete='off'
             disabled={true}
             placeholder={handlePlaceholder(userName)}
             value={userName}
            ></TextInput>
             <div className='title-text-input'>סיסמא</div>
            <TextInput
             className='otp-password-input'
             name='password'
             type='text'
             pattern='[0-9]*'
             id='password'
             maxLength='10'
             autoComplete='off'
             disabled={true}
             placeholder={handlePlaceholder(props.internetDetails?.password)}
             value={props.internetDetails?.password}
            ></TextInput>
        </div>
        </div>
        <div className='button-wrapper'>
            <BtnWhiteBlackBorderBigSize
                onclick={handleOnContinue}
                text='חזרה לאיזור האישי'
            />
        </div>
      </div>
  );
};

const mapStateToProps = (state) => {
  return {
    internetDetails: state.connectionDetailsBlock.internetDetails,
  };
};

const mapDispatchToProps = {  };

export default connect(mapStateToProps, mapDispatchToProps)(ConnectionDetailsPage);
